<h4 class="mat-h4 title">External Participants</h4>

<app-basic-user-avatar-card
  [userId]="externalUserId"
  [name]="externalName"
  [descriptionItems]="[
    { content: externalEmail },
    { content: externalPhoneNumber | phoneFormat }
  ]"
  [fetchImage]="false"
  [padding]="'9px 0px'"
  [isExternal]="true"
/>